import { NgModule } from '@angular/core';
import { SearchEngineModule } from '../../../search-engine/search-engine.module';
import { SharedModule } from '../../../shared/shared.module';
import { HolidaySearchService } from './services/holiday-search.service';
import { FilteredHolidayListPipe } from './pipes/filtered-holiday-list.pipe';

import { HolidaySearchCardComponent } from './components/holiday-search-card/holiday-search-card.component';
import { HolidaySearchFiltersComponent } from './components/holiday-search-filters/holiday-search-filters.component';
import { HolidaySearchListComponent } from './components/holiday-search-list/holiday-search-list.component';
import { HolidaySearchPaginationComponent } from './components/holiday-search-pagination/holiday-search-pagination.component';
import { HolidaySearchComponent } from './holiday-search.component';

@NgModule({
  declarations: [
    HolidaySearchComponent,
    HolidaySearchFiltersComponent,
    HolidaySearchListComponent,
    HolidaySearchCardComponent,
    HolidaySearchPaginationComponent,
    FilteredHolidayListPipe
  ],
  imports: [
    SharedModule,
    SearchEngineModule
  ],
  providers: [
    HolidaySearchService
  ],
  exports: [
    HolidaySearchComponent
  ]
})
export class HolidaySearchPageModule {
}
